var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_561_67289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#929292"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_561_67289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0047 13.4047L7.10469 18.3047C6.92135 18.488 6.68802 18.5797 6.40469 18.5797C6.12135 18.5797 5.88802 18.488 5.70469 18.3047C5.52135 18.1214 5.42969 17.888 5.42969 17.6047C5.42969 17.3214 5.52135 17.088 5.70469 16.9047L10.6047 12.0047L5.70469 7.10469C5.52135 6.92135 5.42969 6.68802 5.42969 6.40469C5.42969 6.12135 5.52135 5.88802 5.70469 5.70469C5.88802 5.52135 6.12135 5.42969 6.40469 5.42969C6.68802 5.42969 6.92135 5.52135 7.10469 5.70469L12.0047 10.6047L16.9047 5.70469C17.088 5.52135 17.3214 5.42969 17.6047 5.42969C17.888 5.42969 18.1214 5.52135 18.3047 5.70469C18.488 5.88802 18.5797 6.12135 18.5797 6.40469C18.5797 6.68802 18.488 6.92135 18.3047 7.10469L13.4047 12.0047L18.3047 16.9047C18.488 17.088 18.5797 17.3214 18.5797 17.6047C18.5797 17.888 18.488 18.1214 18.3047 18.3047C18.1214 18.488 17.888 18.5797 17.6047 18.5797C17.3214 18.5797 17.088 18.488 16.9047 18.3047L12.0047 13.4047Z",
    fill: "#929292"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.4e995e75e8b6fdab775ac17db47c2b66.svg";